<template>
  <div class="AboutOrg px-4">
    <div class="">
      {{ $t('aboutOrg.identifyPrompt') }}
    </div>

    <br />
    <div class="col-md-12">
      <i class="icon icon-profile"></i>
      <label for="first-name">
        {{ $t('aboutOrg.nameLabel') }}
      </label>
    </div>

    <div class="row">
      <div class="col-md-6">
        <input
            v-model="firstName"
            type="text"
            id="first-name"
            name="firstName"
            @blur="userInfoStore.exitedField"
            @change="userInfoStore.firstNameChanged"
            value
            :placeholder="$t('aboutOrg.firstNamePlaceholder')"
            class="col-md-12"
            :disabled="!editMode"
        />
      </div>

      <div class="col-md-6">
        <input
            v-model="lastName"
            type="text"
            id="last-name"
            name="lastName"
            @blur="userInfoStore.exitedField"
            @change="userInfoStore.lastNameChanged"
            :disabled="!editMode"
            value
            :placeholder="$t('aboutOrg.lastNamePlaceholder')"
            class="col-md-12"
        />
      </div>
    </div>

    <br />

    <div class="row justify-content-center align-items-center">
      <div class="col-md-12">
        <i class="icon icon-profile"></i>
        <label for="org-name">
          {{ $t('aboutOrg.communityOrgNameLabel') }}
        </label>
      </div>
      <div class="col-md-12">
        <input
            v-model="orgName"
            type="text"
            id="org-name"
            name="orgName"
            @blur="userInfoStore.exitedField"
            @change="userInfoStore.orgNameChanged"
            :disabled="!editMode"
            value
            :placeholder="$t('aboutOrg.communityOrgNamePlaceholder')"
            class="col-md-12"
        />
      </div>
    </div>

    <br />
    <br />

    <div class="sidebar-instructions p-4">
      {{ $t('aboutOrg.placeBasedNote') }}
    </div>
  </div>
</template>

<script src="./_AboutOrg.js" lang="js"></script>
<style src="./_AboutOrg.less" lang="less" scoped></style>
